var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import widgetsDictionary from "@/components/widgets/widgetsDictionary";
import { Input } from "@mui/joy";
export default function PhotoWidget(_a) {
    var widget = _a.widget;
    var width = widget.payload && widget.payload.width ? widget.payload.width : "full";
    var height = widget.payload && widget.payload.height ? widget.payload.height : "full";
    var url = widget.payload && widget.payload.url ? widget.payload.url : "";
    var title = widget.payload && widget.payload.imageTitle
        ? widget.payload.imageTitle
        : "";
    var alt = widget.payload && widget.payload.imageAlt ? widget.payload.imageAlt : "";
    return (_jsx("div", __assign({ className: "widget-content" }, { children: _jsx("figure", { children: _jsxs("div", __assign({ className: "image-container relative w-".concat(width, " h-").concat(height) }, { children: [_jsx("img", { src: "".concat(url), title: "".concat(title), alt: "".concat(alt) }), _jsx("div", __assign({ className: "image-overlay flex absolute justify-end items-end top-0 left-0 w-full h-full bg-transparent pointer-events-none" }, { children: _jsx("div", __assign({ className: "overlay-content text-base p-1 opacity-[0.5]" }, { children: widget.payload && widget.payload.overlay
                                ? widget.payload.overlay
                                : "" })) }))] })) }) })));
}
function PhotoWidgetSettings(_a) {
    var widget = _a.widget, onChange = _a.onChange;
    return (_jsxs("div", { children: [_jsx("label", { children: "Title" }), _jsx(Input, { slotProps: {
                    input: {
                        id: "title",
                    },
                }, value: (widget === null || widget === void 0 ? void 0 : widget.payload.imageTitle) || "", onChange: function (event) {
                    var value = event.target.value;
                    onChange &&
                        onChange(widget, __assign(__assign({}, widget.payload), { imageTitle: value }));
                } }), _jsx("label", { children: "Url" }), _jsx(Input, { slotProps: {
                    input: {
                        id: "url",
                    },
                }, value: (widget === null || widget === void 0 ? void 0 : widget.payload.url) || "https://source.unsplash.com/300x200/?inspire", onChange: function (event) {
                    var value = event.target.value;
                    onChange && onChange(widget, __assign(__assign({}, widget.payload), { url: value }));
                } }), _jsx("label", { children: "Alt" }), _jsx(Input, { slotProps: {
                    input: {
                        id: "alt",
                    },
                }, value: (widget === null || widget === void 0 ? void 0 : widget.payload.imageAlt) || "", onChange: function (event) {
                    var value = event.target.value;
                    onChange && onChange(widget, __assign(__assign({}, widget.payload), { imageAlt: value }));
                } }), _jsx("label", { children: "Overlay" }), _jsx(Input, { slotProps: {
                    input: {
                        id: "overlay",
                    },
                }, value: (widget === null || widget === void 0 ? void 0 : widget.payload.overlay) || "", onChange: function (event) {
                    var value = event.target.value;
                    onChange && onChange(widget, __assign(__assign({}, widget.payload), { overlay: value }));
                } }), _jsx("label", { children: "Width" }), _jsx(Input, { slotProps: {
                    input: {
                        id: "width",
                    },
                }, value: widget === null || widget === void 0 ? void 0 : widget.payload.width, onChange: function (event) {
                    var value = event.target.value;
                    onChange && onChange(widget, __assign(__assign({}, widget.payload), { width: value }));
                } }), _jsx("label", { children: "Height" }), _jsx(Input, { slotProps: {
                    input: {
                        id: "height",
                    },
                }, value: widget === null || widget === void 0 ? void 0 : widget.payload.height, onChange: function (event) {
                    var value = event.target.value;
                    onChange && onChange(widget, __assign(__assign({}, widget.payload), { height: value }));
                } })] }));
}
widgetsDictionary.register("dev/image/test", {
    name: "Image",
    display: PhotoWidget,
    settings: PhotoWidgetSettings,
});
